export class AccountResponseDto {
  bban?: string;
  bic?: string;
  cashAccountType?: string;
  currency?: string;
  details?: string;
  displayName?: string;
  iban?: string;
  linkedAccounts?: string;
  msisdn?: string;
  name?: string;
  ownerAddressUnstructured?: string;
  ownerName?: string;
  product?: string;
  resourceId?: string;
  status?: string;
  scan?: string;
  usage?: string;
}

export class AccountDetailsResponseDto {
  account: AccountResponseDto
}